/**
 * Value
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UserText from 'components/media/UserText/Loadable.js';

function Value(props) {
  const { value } = props;
  if (value === undefined || value === null) {
    return '-';
  }
  switch (typeof value) {
    case 'string':
      return <UserText>{value}</UserText>;
    case 'object':
      return value.id ? <FormattedMessage {...value} /> : value;
    default:
      return value.toString();
  }
}

Value.propTypes = {
  value: PropTypes.any,
};

export default Value;
